import {CrudService} from "@/services/crud-service";
import {User} from "@/models/user-model";
import axios from "axios";
import {config} from "@/appconfig";
import {TsObjFactory} from "@/helper/global-helper";

export class BeraterService extends CrudService<User>{
    constructor(){
        super(User, 'berater');
    }

    public async ResendInvitation(entity: User): Promise<boolean>{
        const response = await axios.post(config.apiUrl +this.endpoint + 'resendInvitation/' + entity.Id, null, config.apiHeaders);
        return true;
    }

    public async RemoveOTP(entity: User): Promise<boolean>{
        const response = await axios.post(config.apiUrl +this.endpoint + 'removeOTP/' + entity.Id, null, config.apiHeaders);
        return true;
    }
}
